import { type ValidValueProps } from '@n2-common/components/ValidationFeedbackFormik';
import { FormikInput, type InputProps } from '../Input';
import { FormikFormattedInput } from '../Input/FormattedInput';
import {
    AmountFormat,
    FinnishSsnFormat,
    SwedishSsnFormat,
    SwedishAccountNumberFormat,
    FinnishAccountNumberFormat,
    FinnishPhoneNumberFormat,
    SwedishPhoneNumberFormat,
    NorwegianPhoneNumberFormat,
} from './InputConfigs';

export type CustomInputProps = Omit<InputProps, 'type' | 'autoComplete' | 'uiType'> & ValidValueProps;

export function SwedishSsnInput(props: CustomInputProps) {
    return <FormikFormattedInput {...props} {...SwedishSsnFormat} autoComplete="on" />;
}

export function FinnishSsnInput(props: CustomInputProps) {
    return <FormikFormattedInput {...props} {...FinnishSsnFormat} autoComplete="on" />;
}

export function AccountnumberInput(props: CustomInputProps & CountryProps) {
    switch (props.country) {
        case 'FI':
            return <FinnishAccountNumberInput {...props} />;

        case 'SE':
            return <SwedishAccountNumberInput {...props} />;

        default:
            return <FormikInput {...props} type="tel" />;
    }
}

export function SwedishAccountNumberInput(props: CustomInputProps) {
    return <FormikFormattedInput {...props} {...SwedishAccountNumberFormat} autoComplete="on" />;
}

export function FinnishAccountNumberInput(props: CustomInputProps) {
    return <FormikFormattedInput {...props} {...FinnishAccountNumberFormat} autoComplete="on" />;
}

export function AmountInput(props: CustomInputProps) {
    return <FormikFormattedInput {...props} {...attribsFromFieldType('Amount')} {...AmountFormat} />;
}
export function FinnishAmountInput(props: CustomInputProps) {
    return <FormikFormattedInput {...props} prefix="€" {...attribsFromFieldType('Amount')} {...AmountFormat} />;
}

export function NationalIdInput(props: CustomInputProps) {
    return <FormikInput {...props} {...attribsFromFieldType('NationalId')} />;
}

export function EmailInput(props: CustomInputProps) {
    return <FormikInput {...props} {...attribsFromFieldType('Email')} />;
}

export function PhoneNumberInput(props: CustomInputProps) {
    return <FormikInput {...props} {...attribsFromFieldType('PhoneNumber')} />;
}

export function NorwegianMobilePhoneNumberInput(props: CustomInputProps) {
    return <FormikFormattedInput {...props} {...NorwegianPhoneNumberFormat} autoComplete="on" />;
}
export function FinnishMobilePhoneNumberInput(props: CustomInputProps) {
    return <FormikFormattedInput {...props} {...FinnishPhoneNumberFormat} autoComplete="on" />;
}
export function SwedishMobilePhoneNumberInput(props: CustomInputProps) {
    return <FormikFormattedInput {...props} {...SwedishPhoneNumberFormat} autoComplete="on" />;
}

type InputFieldType = 'Amount' | 'Email' | 'NationalId' | 'PhoneNumber';

const inputTypeFromFieldType = (fieldtype: InputFieldType): React.HTMLInputTypeAttribute => {
    switch (fieldtype) {
        case 'Amount':
            return 'amount';
        case 'Email':
            return 'text';
        case 'NationalId':
            return 'tel';
        case 'PhoneNumber':
            return 'tel';
    }
};
const autoCompleteFromFieldType = (fieldtype: InputFieldType): React.HTMLInputTypeAttribute => {
    switch (fieldtype) {
        case 'Amount':
            return 'on';
        case 'Email':
            return 'email';
        case 'NationalId':
            return 'on';
        case 'PhoneNumber':
            return 'tel';
    }
};

function attribsFromFieldType(fieldType: InputFieldType) {
    const type = inputTypeFromFieldType(fieldType);
    const autoComplete = autoCompleteFromFieldType(fieldType);
    return { type, autoComplete };
}
